import styled from "styled-components";
import { Colors} from "@shared/styles/colors";

const LoginPageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: ${Colors.loginPurple};
`;

const LeftContainer = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.defaultContainerColor};
  border-radius: 0 80px 80px 0;
  z-index: 1;
  box-shadow: 4px 0px 4px 0px rgba(60, 60, 60, 0.4);
  transition: flex 0.3s ease-in-out; /* width 애니메이션 */@
  @media (max-width: 830px) {
    flex: 2;
  }
  @media (max-width: 720px) {
    width: 50%;
  }
`;

const RightContainer = styled.div`
  flex: 1;
  background-color: ${Colors.loginPurple};
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding: 48px;
  @media (max-width: 640px) {
    padding: 0 24px;
  }
`;

const LoginLogo = styled.img`
  width: 194px;
  margin-top: 32px;
  transition: width 0.3s ease-in-out; /* width 애니메이션 */@
  @media (max-width: 1155px) {
    width: 140px;
  }
  @media (max-width: 767px) {
    width: 100px;
  }
  
`;

const SubText = styled.div`
  font-family: Pretendard, emoji;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.5;
  text-align: left;
  line-height: normal;

  transition: font-size 0.3s ease-in-out; /* width 애니메이션 */@
  media (max-width: 1410px) {
    font-size: 24px;
  }
  @media (max-width: 1155px) {
    font-size: 16px;
  }
  @media (max-width: 825px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 13px;
  }
  @media (max-width: 497px) {
    display: none;
  }
`;

const SubText2 = styled.div`
  font-family: Pretendard, emoji;
  font-size: 60px;
  font-weight: bold;
  line-height: 1.5;
  text-align: left;
  transition: font-size 0.3s ease-in-out; /* width 애니메이션 */@
  @media (max-width: 1410px) {
    font-size: 48px;
  }
  @media (max-width: 1155px) {
    font-size: 32px;
  }
  @media (max-width: 767px) {
    font-size: 24px;
  }
  @media (max-width: 575px) {
    font-size: 20px;
  }
  @media (max-width: 497px) {
    display: none;
  }
  // line-height: n
  // ormal;
`;

const LoginContainer = styled.div`
  background-color: ${Colors.defaultContainerColor};
  width: 470px;
  padding: 40px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: left;
  @media (max-width: 830px) {
    width: 400px;
  }
  @media (max-width: 720px) {
    width: 80%;
    padding: 20px;
  }
`;

const LoginButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  // margin-top: 16px;
  padding: 12px 0;
  box-sizing: border-box;

  
  @media (max-width: 714px) {
    width: 80%;
    transition: width 0.3s ease-in-out; /* width 애니메이션 */@
  }

`;

const LoginImage = styled.img`
  width: 400px;
  margin-bottom: 32px;
  @media (max-width: 500px) {
    width: 300px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 13px 10px;
  margin-bottom: 22px;
  border: 1px solid ${Colors.tableBorderColor};
  border-radius: 8px;
  font-size: 16px;
  box-sizing: border-box;
  transition: width 0.3s ease-in-out; /* width 애니메이션 */@
  &:focus {
    outline: none;
  }
  @media (max-width: 714px) {
    width: 100%;
  }
  

  
`;

export const s = {
    LoginPageContainer,
    LeftContainer,
    RightContainer,
    LoginLogo,
    SubText,
    SubText2,
    LoginContainer,
    LoginButtonContainer,
    LoginImage,
    StyledInput,
};
